export const CATEGORY_DICTIONARY = [
  'AM',
  'A1',
  'A2',
  'A',
  'B1',
  'B',
  'B+E',
  'C1',
  'C1+E',
  'C',
  'C+E',
  'D1',
  'D1+E',
  'D',
  'D+E',
  'T',
  'KWALIFIKACJA_WSTEPNA',
  'SZKOLENIE_OKRESOWE'
];
